\:host
    width: 100%

.CartDetailsContainer
    display: flex
    flex-direction: row
    flex: 1
    align-items: flex-end
    justify-content: space-between
    z-index: $indexCartButton
    cursor: pointer
    stroke: rgb($globalSettingsFontPrimary)
    color: rgb($globalSettingsFontPrimary)
    &:hover
        stroke: rgb($globalSettingsFontSecondary)
        color: rgb($globalSettingsFontSecondary)

.CartDetailsInfo
    display: flex
    flex-direction: column

.CartDetailsPriceContainer
    display: flex
    flex-direction: row
    align-items: center
    gap: 10px
    cursor: pointer
    .CartDetailsPrice
        display: flex
        flex-direction: column
        align-items: flex-end
        font-size: 14px
        font-weight: 700
        span
            font-size: 12px
            font-weight: 400
    svg
        transform: rotateX(180deg)

.CartDetailsArticle
    display: flex
    flex-direction: row
    align-items: center
    gap: 10px
    svg
        width: 20px
        height: 20px

